import React from 'react'
import CoZajistime from '../Components/CoZajistime'
import { Container } from '@mui/material'
import Cenik from '../Components/Cenik'
import Calculation from '../Components/Calculation'
import CookieBar from '../Components/CookieBar'

export default function MainPage() {
    return (
        <>
            <CookieBar />
            <Container maxWidth='xl'>
                <CoZajistime />
                <Cenik />
                <Calculation />
            </Container>
        </>
    )
}
